export enum ApiCurrencySymbols {
  UTK = 'UTK',
  BNB = 'BNB',
  BUSD = 'BUSD',
  USDT = 'USDT',
  BTC = 'BTC',
  ETH = 'ETH',
  AVAX = 'AVAX',
  USDC = 'USDC',
  SOL = 'SOL',
  EGLD = 'EGLD',
  DASH = 'DASH',
  POL = 'POL',
  SUI = 'SUI',
}

export type ApiCurrencySymbolKeys = keyof typeof ApiCurrencySymbols;

export enum ApiChainSymbols {
  BTC = 'BTC',
  'LN-BTC' = 'LN-BTC',
  ETH = 'ETH',
  BASE = 'BASE',
  ERD = 'ERD',
  DASH = 'DASH',
  MATIC = 'MATIC',
  POLYGON = 'POLYGON',
  BSC = 'BSC',
  TRX = 'TRX',
  SUI = 'SUI',
  HEDERA = 'HEDERA',
  BinancePay = 'BinancePay',
  WalletConnectPay = 'WalletConnectPay',
  SOL = 'SOL',
  SOLANA = 'SOLANA',
}

export const binancePayAsBlockchain = ApiChainSymbols.BinancePay;
export const binancePayDefaultCurrency = ApiCurrencySymbols.USDC;

export type ApiChainSymbolKeys = keyof typeof ApiChainSymbols;
